var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{ref:"blocks",staticClass:"blocks",attrs:{"data-menucolor":"black"}},_vm._l((_vm.data),function(block,k){return _c(block.type + '_block',{key:k,tag:"component",staticClass:"block",attrs:{"data":block[block.type]}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }